import React from 'react';
import { SeoData } from '../hooks/useSeo';

interface Props {
  seo: SeoData | null;
}

// React 19 supports metadata tags directly; React will manage <head> updates.
export function SeoHead({ seo }: Props) {
  if (!seo) return null;
  return (
    <>
      {seo.title ? <title>{seo.title}</title> : null}
      {seo.description ? <meta name="description" content={seo.description} /> : null}
      {seo.canonicalUrl ? <link rel="canonical" href={seo.canonicalUrl} /> : null}
      {seo.noindex ? <meta name="robots" content="noindex" /> : null}
      {/* OpenGraph */}
      {seo.ogTitle ? <meta property="og:title" content={seo.ogTitle} /> : null}
      {seo.ogDescription ? <meta property="og:description" content={seo.ogDescription} /> : null}
      {seo.ogImageUrl ? <meta property="og:image" content={seo.ogImageUrl} /> : null}
      {seo.canonicalUrl ? <meta property="og:url" content={seo.canonicalUrl} /> : null}
      <meta property="og:type" content="website" />
      {/* Twitter */}
      {seo.twitterCard ? <meta name="twitter:card" content={seo.twitterCard} /> : null}
      {seo.ogTitle ? <meta name="twitter:title" content={seo.ogTitle} /> : null}
      {seo.ogDescription ? <meta name="twitter:description" content={seo.ogDescription} /> : null}
      {seo.ogImageUrl ? <meta name="twitter:image" content={seo.ogImageUrl} /> : null}
      {/* Intentionally omit JSON-LD client-side to avoid duplication with server-injected script */}
    </>
  );
}

